export default {
  text: 'Valmistelemme pöytääsi 🍽…',
};
